import styled from 'styled-components'
import { Grid } from '@mui/material'

export const Container = styled(Grid)`
  display: flex;
  justify-items: center;
`
